import axios from 'axios';

export const API_BASE_URL =
  window.location.hostname === 'localhost'
    ? 'http://127.0.0.1:8000'          // ローカル開発用
    : 'https://messenagoya.ex-link.net'; // 本番 HTTPS
const api = axios.create({
  baseURL: API_BASE_URL,
  // JWT は JavaScript から読めない HttpOnly Cookie で送信する。
  withCredentials: true,
  xsrfCookieName: "csrf_token",
  xsrfHeaderName: "X-CSRF-Token",
  withXSRFToken: true,
});

// 🚀 リクエストインターセプターでContent-Typeを動的に設定
api.interceptors.request.use((config) => {
  if (config.data instanceof FormData) {
    // FormDataのときは multipart/form-data にする
    config.headers['Content-Type'] = 'multipart/form-data';
  } else {
    // それ以外は application/json にする
    config.headers['Content-Type'] = 'application/json';
  }
  return config;
});

export default api;
